import styled from "styled-components";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import SpotTemplate from "../../custom/spot/SpotTemplate";
import RemoveIcon from "@mui/icons-material/Remove";
import { Helmet } from "react-helmet";

const FooterLinksContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
    p {
      margin: 0px;
    }

    .contenedor_footer_principal {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 10px;
      border-top: solid 1px #263645;
      padding-top: 10px;
    }

    .contenedor_footer_secundario {
      display: flex;
      flex-direction: column;
      align-item: center;
      justify-content: start;
      width: 100%;
      gap: 10px;
    }

    .footer_enlace {
      font-family: Inter;
      color: #263645;
      font-size: 16px;
      width: 100%;
    }

    span.footer_enlace_span {
      font-family: Inter;
      text-transform: capitalize;
    }

    .footer_enlance_cabecera {
      font-family: 'Inter';
      font-weight: 600;
      font-size: 15px;
      color: #263645;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .footer_ocultar_mobile {
      display: none;
    }

    .icono_ocultar {
      height: 2px;
      width: 18px;
      background-color: black;
    }

    .icono_desplegar {
      display: none;
      width: 25px;
      height: 25px;
      border-radius: 5px;

      &:after {
        width: 18px;
        height: 2px;
        left: 4px;
        top: 12px;
      }

      &:before {
        width: 2px;
        height: 18px;
        left: 12px;
        top: 4px;
      }
    ;
    border-radius: 10px;
    position: relative;

    &:after, &:before {
      content: '';
      position: absolute;
      background: black;
      border-radius: 5px;
    }
  }

  .contenedor_enlaces_footer {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @keyframes expandHeightIn {
    0% {
      height: 0;
    }
    20% {
      height: 80px;
    }
    30% {
      height: 100px;
    }
    40% {
      height: 120px;
    }
    60% {
      height: 160px;
    }
    80% {
      height: 200px;
    }
    90% {
      height: 240px;
    }
    100% {
      height: 100%;
    }
  }

  @keyframes expandHeightOut {
    0% {
      height: 100%;
    }
    20% {
      height: 160px;
    }
    40% {
      height: 120px;
    }
    60% {
      height: 80px;
    }
    80% {
      height: 40px;
    }
    100% {
      height: 0;
    }
  }

  .contenedor_enlaces_footer_movil {
    display: flex;
    height: 0;
    overflow: hidden;
    flex-direction: column;
    gap: 10px;
    transition: height 0.5s ease-in;
    margin-bottom: 10px;
  }

  .clase_display {
    animation: expandHeightIn 0.5s ease-in;
    height: 100%;
  }

  .contenedor_enlaces_footer_movil:not(.clase_display) {
    animation: expandHeightOut 0.5s ease-in;
  }

  .version_movil {
    display: grid;
    grid-template-rows: repeat(1, 1fr);
  }

  .version_desktop {
    display: none;
  }

    // VERSION DESKTOP
    @media (min-width: ${theme.breakpoints.values.sm}px) {
      .contenedor_footer_principal {
        border: none;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(1, 1fr);
        column-gap: 60px;
        padding-top: 10px;
      }

      .footer_enlance_cabecera {
        font-size: 15px;
        color: #263645;
      }

      .footer_ocultar_mobile {
        display: block;
        font-size: 15px;
        color: #263645;
      }

      .footer_enlace {
        font-family: Inter;
        color: #263645;
        font-size: 15px;
      }

      .contenedor_iconos_desplegar_mostrar {
        display: none;
      }

      .version_movil {
        display: none;
      }

      .version_desktop {
        display: grid;
      }
    }
`}
`;

export const FooterLinks = () => {
  return (
    <FooterLinksContainer>
      {/* eventos iconos IconoDesplegarObtenerAyuda + y IconoOcultarObtenerAyuda - */}
      <Helmet>
        <script type="text/javascript">{`
    let IconoDesplegarObtenerAyuda = document.querySelector("#IconoDesplegarObtenerAyuda");
    let IconoOcultarObtenerAyuda = document.querySelector("#IconoOcultarObtenerAyuda");

    function timeoutLinks(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function leerContenedorFooter(iconId) {
      let foundButton = document.querySelector(iconId);

      if (foundButton != null) {
        foundButton.addEventListener('click', mostrarLinksObtenerAyuda);
        return foundButton;
      }

      return null;
    }

    async function comprobarIconos(iconId) {
      let icon = await leerContenedorFooter(iconId);

      while (icon == null || icon == undefined) {
        await timeoutLinks(1000);
        icon = await leerContenedorFooter(iconId);
      }
    }

    function mostrarLinksObtenerAyuda() {
      const linksContainers = document.querySelectorAll('.contenedor_enlaces_footer_movil');
      const iconoDesplegarObtenerAyuda = document.querySelector("#IconoDesplegarObtenerAyuda");
      const iconoOcultarObtenerAyuda = document.querySelector("#IconoOcultarObtenerAyuda");

      linksContainers.forEach(linksContainer => {
        const hasClaseDisplay = linksContainer.classList.contains('clase_display');

        if (!hasClaseDisplay) {
          linksContainer.classList.add('clase_display');
          iconoDesplegarObtenerAyuda.style.display = 'none';
          iconoOcultarObtenerAyuda.style.display = 'block';
        } else {
          linksContainer.classList.remove('clase_display');
          iconoDesplegarObtenerAyuda.style.display = 'block';
          iconoOcultarObtenerAyuda.style.display = 'none';
        }
      });
    }

    comprobarIconos("#IconoDesplegarObtenerAyuda");
    comprobarIconos("#IconoOcultarObtenerAyuda");
  `}</script>
      </Helmet>

      {/* codigo html del Spot */}
      {/* <div>
        <div className="contenedor_footer_principal version_desktop">
          <div className="contenedor_footer_secundario">
            <div data-url="/" className="footer_enlance_cabecera">
              <p>
                <span className="footer_enlace_span">obtener</span> ayuda
              </p>
            </div>
            <div className="contenedor_enlaces_footer">
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">estatus</span> de mi pedido
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">cambios</span> y devoluciones
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">formas</span> de pago
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">entregas</span> y envios
                </p>
              </div>
            </div>
          </div>
          <div className="contenedor_footer_secundario">
            <div data-url="/" className="footer_enlance_cabecera footer_ocultar_mobile">
              <p>
                <span className="footer_enlace_span">sobre</span> onboard
              </p>
            </div>
            <div className="contenedor_enlaces_footer">
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">quienes</span> somos
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">contactenos</span>
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">terminos</span> de promociones
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">preguntas</span> frecuentes
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="contenedor_footer_principal version_movil">
          <div className="contenedor_footer_secundario">
            <div data-url="/" className="footer_enlance_cabecera">
              <p>
                <span className="footer_enlace_span">obtener</span> ayuda
              </p>
              <div className="contenedor_iconos_desplegar_mostrar">
                <div className="icono_ocultar" id="IconoOcultarObtenerAyuda"></div>
                <div className="icono_desplegar" id="IconoDesplegarObtenerAyuda"></div>
              </div>
            </div>

            <div className="contenedor_enlaces_footer_movil clase_display">
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">estatus</span> de mi pedido
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">cambios</span> y devoluciones
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">formas</span> de pago
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">entregas</span> y envios
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">quienes</span> somos
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">contactenos</span>
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">terminos</span> de promociones
                </p>
              </div>
              <div data-url="/" className="footer_enlace">
                <p>
                  <span className="footer_enlace_span">preguntas</span> frecuentes
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Espot FooterLinks */}
      <SpotTemplate espotName={"FooterLinks"} />
    </FooterLinksContainer>
  );
};
